import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { useConfig } from 'docz';
import { values } from 'lodash/fp';
import { useMemo } from 'react';
export var NO_GROUP = '';

if (typeof NO_GROUP !== 'undefined' && NO_GROUP && NO_GROUP === Object(NO_GROUP) && Object.isExtensible(NO_GROUP) && !NO_GROUP.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NO_GROUP, '__filemeta', {
    configurable: true,
    value: {
      name: "NO_GROUP",
      filename: "node_modules/@nejcm/docz-theme-extended/src/hooks/useGroups.js"
    }
  });
}

function useGroups(menus) {
  var _useConfig = useConfig(),
      groups = _useConfig.groups;

  return useMemo(function () {
    if (!groups || Object.keys(groups).length === 0) {
      var _ref;

      return _ref = {}, _ref[NO_GROUP] = menus, _ref;
    }

    if (!Array.isArray(menus)) {
      return menus;
    }

    var menusObject = menus.reduce(function (acc, curr) {
      acc[curr.name || ''] = curr;
      return acc;
    }, {});
    var grouped = Object.keys(groups).filter(function (key) {
      return Array.isArray(groups[key]);
    }).reduce(function (acc, key) {
      acc[key] = groups[key].map(function (group) {
        var val = menusObject[group];
        delete menusObject[group];
        return val;
      });
      return acc;
    }, {});
    grouped[NO_GROUP] = [].concat(_toConsumableArray(grouped[NO_GROUP] || []), _toConsumableArray(values(menusObject) || []));
    return grouped;
  }, [groups, menus]);
}

export default useGroups;

if (typeof useGroups !== 'undefined' && useGroups && useGroups === Object(useGroups) && Object.isExtensible(useGroups) && !useGroups.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useGroups, '__filemeta', {
    configurable: true,
    value: {
      name: "useGroups",
      filename: "node_modules/@nejcm/docz-theme-extended/src/hooks/useGroups.js"
    }
  });
}